export default __webpack_public_path__ + "static/media/team1.6d756943.png";